<script setup lang="ts">
import { useAuthStore } from '@/stores/auth'
import { onAuthStateChanged } from 'firebase/auth'
import { auth } from '@/services/firebase/config'
import LegalConsentModal from '@/components/legal/LegalConsentModal.vue'

const authStore = useAuthStore()

// Keep auth store in sync with Firebase Auth state changes (login, logout, token refresh)
onAuthStateChanged(auth, (user) => {
  authStore.setUser(user)
})
</script>

<template>
  <router-view v-slot="{ Component }">
    <transition
      name="fade"
      mode="out-in"
    >
      <component :is="Component" />
    </transition>
  </router-view>
  <!-- Consentimiento de los términos: modal único, fuera de las vistas (ADR-SEC-013 local) -->
  <LegalConsentModal />
</template>

<style>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.15s ease;
}
.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
